import {
  DEFECT_IMAGE_LAUNCHABLE_ID,
  SENSOR_CARLINE_LAUNCHABLE_ID,
  VIDEO_AUGMENTATION_LAUNCHABLE_ID,
} from "constants/pipelines";

export const LAUNCHABLE_SKIN = {
  NEMOCLAW: "nemoclaw",
  PHYSICAL_AI_SENSOR_CARLINE: "physical-ai-sensor-carline",
  PHYSICAL_AI_DEFECT_IMAGE: "physical-ai-defect-image",
  PHYSICAL_AI_VIDEO_AUGMENTATION: "physical-ai-video-augmentation",
} as const;

export type LaunchableSkin =
  (typeof LAUNCHABLE_SKIN)[keyof typeof LAUNCHABLE_SKIN];

const nemoClawLaunchableId = import.meta.env.VITE_NEMOCLAW_LAUNCHABLE_ID as
  | string
  | undefined;

export function resolveLaunchableSkin(
  launchableId: string | null | undefined,
): LaunchableSkin | null {
  if (!launchableId) return null;
  if (nemoClawLaunchableId && launchableId === nemoClawLaunchableId) {
    return LAUNCHABLE_SKIN.NEMOCLAW;
  }
  if (launchableId === SENSOR_CARLINE_LAUNCHABLE_ID) {
    return LAUNCHABLE_SKIN.PHYSICAL_AI_SENSOR_CARLINE;
  }
  if (launchableId === DEFECT_IMAGE_LAUNCHABLE_ID) {
    return LAUNCHABLE_SKIN.PHYSICAL_AI_DEFECT_IMAGE;
  }
  if (launchableId === VIDEO_AUGMENTATION_LAUNCHABLE_ID) {
    return LAUNCHABLE_SKIN.PHYSICAL_AI_VIDEO_AUGMENTATION;
  }
  return null;
}

export function isPhysicalAISkin(skin: LaunchableSkin | null): boolean {
  return (
    skin === LAUNCHABLE_SKIN.PHYSICAL_AI_SENSOR_CARLINE ||
    skin === LAUNCHABLE_SKIN.PHYSICAL_AI_DEFECT_IMAGE ||
    skin === LAUNCHABLE_SKIN.PHYSICAL_AI_VIDEO_AUGMENTATION
  );
}

export function hasSkinHeading(skin: LaunchableSkin | null): boolean {
  return isPhysicalAISkin(skin);
}
